import { FC, useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

import { foreignProfileSendWinkAction } from 'actions/foreignProfile/foreignProfileSendWinkAction'
import { toggleFavoriteAction } from 'actions/messengerAction'
import { ThenPlace } from 'components/block/Then/Then.constants'
import { ThenParams } from 'components/block/Then/Then.paths'
import {
  chatPath,
  contactPath,
  profilePath,
  ProfileRouteParams,
} from 'components/paths'
import {
  giftPresentPath,
  storeFrontGiftToUserPath,
  storeFrontTopUpPath,
  storeFrontVipPath,
} from 'components/storefront/StoreFront.paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { push, replace } from 'functions/router'
import { useReducersInsert } from 'hooks/useReducersInsert'
import { chatMessengerReducer } from 'reducers/messenger/chatMessengerReducer'

export const UserProfileThen: FC = () => {
  const { userId, place } = useParams<ThenParams & ProfileRouteParams>()
  const dispatch = useDispatch()
  useReducersInsert({ chatMessengerReducer })

  useEffect(() => {
    const profileId = Number(userId)
    // Заменим /profile/userId/then/gift, чтобы не попасть в петлю
    dispatch(replace(mergeAllUrls(profilePath, userId)))

    switch (place) {
      case ThenPlace.messenger:
        dispatch(replace(mergeAllUrls(chatPath, userId, contactPath)))
        break
      case ThenPlace.wink:
        dispatch(foreignProfileSendWinkAction(profileId))
        break
      case ThenPlace.favourite:
        dispatch(toggleFavoriteAction(profileId))
        break
      case ThenPlace.gift:
        dispatch(
          push(
            mergeAllUrls(
              profilePath,
              userId,
              storeFrontGiftToUserPath,
              userId,
              giftPresentPath
            )
          )
        )
        break
      case ThenPlace.vip:
        dispatch(push(mergeAllUrls(profilePath, userId, storeFrontVipPath)))
        break
      case ThenPlace.topUp:
        dispatch(push(mergeAllUrls(profilePath, userId, storeFrontTopUpPath)))
        break
      default:
        console.warn(`Place "${place}" is not implemented`)
    }
  }, [dispatch, place, userId])
  return null
}
